import React, { useState, useRef } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة اختبار النظر - حاسبة فحص وقياس النظر";
const DESCRIPTION = "تقوم الحاسبة بإجراء فحص للأعين بشكل بسيط وواضح بالاعتماد على اختبار سنيلين";
const KEYWORDS = "حساب عدسة العين, حساب القوة البصيرة";
const OG_URL = "https://do-calculate.com/calculator/ar/eye-test/";
const lines = [
  {
    text: "E",
    size: "90px",
    value: "6/60",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "FP",
    size: "80px",
    value: "6/30",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "T O Z",
    size: "70px",
    value: "6/21",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "L P E D",
    size: "60px",
    value: "6/15",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "P E C F D",
    size: "50px",
    value: "6/12",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "E D F C Z P",
    size: "40px",
    value: "6/9",
    advice: "يجب عليك استشارة الطبيب.",
    test: "bad",
  },
  {
    text: "F E L O P Z D",
    size: "30px",
    value: "6/7.5",
    advice: "استمر في الاهتمام بصحة عينيك.",
    test: "good",
  },
  {
    text: "D E F P O T E C",
    size: "25px",
    value: "6/6",
    advice: "استمر في الاهتمام بصحة عينيك.",
    test: "good",
  },
  {
    text: "L E F O D P C T",
    size: "20px",
    value: "6/6",
    advice: "استمر في الاهتمام بصحة عينيك.",
    test: "good",
  },
  {
    text: "P E F C Z P T O",
    size: "15px",
    value: "6/6",
    advice: "استمر في الاهتمام بصحة عينيك.",
    test: "good",
  },
];
function Calculator() {
  const [result, setResult] = useState(null);
  const resultRef = useRef(null);
  const handleRowClick = (line) => {
    setResult(line);
    console.log(line);
    console.log(result);
    if (resultRef.current) {
      resultRef.current.scrollIntoView();
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  يقدم التطبيق اختبارًا بسيطًا لفحص حدة البصر باستخدام جهازك
                  المحمول. سيتم عرض سلسلة من المخططات البصرية التي تحتوي على
                  حروف وأرقام مختلفة الأحجام. ستحتاج إلى تحديد الحرف أو الرقم
                  الذي يمكنك رؤيته بوضوح من المسافة المحددة. سيتم تقييم قدرتك
                  على رؤية الحروف والأرقام الصغيرة لتحديد حدة بصرك.
                </p>
                <p>كيفية إجراء الاختبار:</p>
                <ul>
                  <li>
                    أنشئ بيئة مريحة: تأكد من وجودك في منطقة ذات إضاءة جيدة مع
                    الحد الأدنى من المشتتات. اضبط سطوح جهازك إلى مستوى مريح.
                  </li>
                  <li>
                    حافظ على المسافة المناسبة: أمسك جهازك على مسافة تقريبية
                    تبلغ 4 أقدام (1.2 متر) من عينيك.
                  </li>
                  <li>
                    غط عينًا واحدة في كل مرة: استخدم يدك لتغطية إحدى عينيك
                    تمامًا أثناء إجراء الاختبار على الأخرى.
                  </li>
                </ul>
                <p>العوامل المؤثرة على دقة الفحص:</p>
                <ul>
                  <li>
                    حجم الشاشة وجودتها: يمكن أن تؤثر حجم الشاشة وجودتها على
                    دقة الاختبار.
                  </li>
                  <li>
                    ظروف الإضاءة: يمكن أن تؤثر الإضاءة غير الكافية أو المفرطة
                    على قدرتك على رؤية المخططات بوضوح.
                  </li>
                  <li>
                    العوامل الفردية: يمكن أن تؤثر عوامل مثل إجهاد العين،
                    الإرهاق، أو أمراض العين الكامنة على دقة الاختبار.
                  </li>
                </ul>
                <p>
                  <b>
                    <u>ملاحظة هامة:</u> يرجى ملاحظة أن هذا الاختبار ليس بديلاً
                    عن الفحص الشامل للعين بواسطة أخصائي رعاية صحية. يوصى
                    باستشارة طبيب العيون للحصول على تقييم دقيق لحالة بصرك. هذا
                    الاختبار مخصص كأداة فحص أولية. إذا واجهت أي تغييرات في
                    رؤيتك، مثل عدم وضوح الرؤية، الرؤية المزدوجة، أو صعوبة
                    القراءة، من الضروري طلب الرعاية الصحية المهنية.
                  </b>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <div className="bg-warning text-black text-center p-3">
                  <p>
                    يرجى اختيار السطر الذي لا يمكنك قراءته بوضوح من أجل عرض
                    النتيجة
                  </p>
                </div>
                <hr />
                <div className="list-group">
                  {lines.map((line, index) => (
                    <div
                      key={index}
                      onClick={() => handleRowClick(line)}
                      className="list-group-item"
                      style={{
                        fontSize: line.size,
                        cursor: "pointer",
                        textAlign: "center",
                        border: "2px solid transparent",
                        borderRadius: "8px",
                        padding: "8px",
                        marginBottom: "10px",
                      }}
                    >
                      {line.text}
                    </div>
                  ))}
                </div>
                {result && (
                  <div
                    ref={resultRef}
                    className={`alert ${
                      result.test === "good" ? "alert-success" : "alert-warning"
                    } mt-4`}
                  >
                    <h4>النتيجة: {result.value}</h4>
                    {result.advice && <p>{result.advice}</p>}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>ما هو اختبار سنيلين؟</h2>{" "}
                  </u>
                  <p>
                    اختبار سنيلين هو فحص لحدة البصر، حيث يقيس القدرة على رؤية
                    التفاصيل الدقيقة.
                  </p>
                  <p>
                    يتكون الاختبار من عدة أسطر تحتوي على أحرف بأحجام مختلفة.
                  </p>
                  <p>كلما تمكنت من قراءة الأحرف الصغيرة، كانت حدة نظرك أفضل.</p>
                  <div className="p-3 mb-2 bg-info  ">مثال على نتيجة 6/6</div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية تفسير النتائج</h2>{" "}
                  </u>
                  <p>يتم تحديد حدة البصر من خلال أصغر خط يمكن للشخص قراءته.</p>
                  <ul>
                    <li>
                      20/20 تعني أن الشخص يستطيع قراءة ما يُفترض أن يراه الشخص
                      العادي على بعد 20 قدم.
                    </li>
                    <li>
                      20/40 تعني أن الشخص يحتاج إلى الاقتراب إلى نصف المسافة
                      لرؤية ما يمكن أن يراه الشخص العادي على بعد 20 قدم.
                    </li>
                  </ul>
                  <p>
                    كلما كانت النسبة أقل من 20/20، كان ذلك مؤشرًا على ضعف البصر.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال على النتيجة: 20/40
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أسئلة شائعة</h2>{" "}
                  </u>
                  <p>هل يمكن تحسين حدة البصر؟</p>
                  <ul>
                    <li>
                      نعم، من خلال النظارات أو العدسات اللاصقة أو الجراحة.
                    </li>
                    <li>ماذا تعني نتيجة 6/60</li>
                    <li>تعني أن الشخص يعاني من ضعف شديد في البصر.</li>
                  </ul>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    النتيجة: 6/60
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;